






























































































































import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, numeric, min, max, email, alpha_num, regex } from 'vee-validate/dist/rules';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle, faHistory, faCalendarDay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Swal from 'sweetalert2';
import { consentInfo, termAndCondInfo } from './consent';

library.add(faInfoCircle);
library.add(faHistory);
library.add(faCalendarDay);

extend('required', required);
extend('numeric', numeric);
extend('min', min);
extend('max', max);
extend('email', email);
extend('alpha_num', alpha_num);
extend('regex', regex);
extend('specialText', {
  validate: (value) => {
    // const special = /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\/\\]/;
    const special = /[a-zA-Z\u0E00-\u0E7F0-9]/;
    const space = /[ ]/;
    const emoji = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/;
    const allow = special.test(value);
    const notSpace = space.test(value);
    const allowEmoji = emoji.test(value);
    return allow && !notSpace && !allowEmoji;
  },
});

enum STATE {
  INIT_DATA,
  CONSENT_FORM,
  REGISTER_FORM,
  OTP_VERIFY,
  REGISTER_RESULT,
}

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    FontAwesomeIcon,
  },
})
export default class TrackingRegisterView extends Vue {
  private consentInfo = consentInfo;
  private termAndCondInfo = termAndCondInfo;
  private userTrackingRegister = null;
  private isConsent = false;
  private form = {
    firstName: null,
    lastName: null,
    telephone: null,
    nickname: null,
    email: null,
  };
  private otpRefCode = null;
  private otpCode = null;
  private resendCounter = 0;
  private ivalId = null;
  private STATE = STATE;
  private state = STATE.INIT_DATA;

  private async created() {
    await this.$http.get('/api/auth');
    const res = await this.$http.get('/api/users/tracking-register');
    if (res.data) {
      this.userTrackingRegister = res.data;
      const { firstName, lastName, telephone, nickname } = this.userTrackingRegister;
      this.form = {
        firstName,
        lastName,
        telephone,
        nickname,
        email: this.userTrackingRegister.email,
      };
      this.state = STATE.REGISTER_FORM;
    } else {
      Swal.fire({
        allowOutsideClick: false,
        title: 'เงื่อนไขการใช้บริการ',
        html:
          `<div class="register-consent-form">
            ${this.consentInfo}
            <hr>
            ${this.termAndCondInfo}
          </div>`,
        focusConfirm: false,
        focusCancel: false,
        customClass: 'swal2-width-full',
        confirmButtonText: 'ตกลง',
        confirmButtonColor: '#ec1b23',
      }).then((result) => {
        if (result.value) {
          this.isConsent = true;
          this.state = STATE.REGISTER_FORM;
        }
      });
    }
  }

  private isRegister(): boolean {
    return this.userTrackingRegister !== null;
  }

  private confirmRegister() {
    Swal.fire({
      title: 'ยืนยัน',
      text: `การลงทะเบียนติดตามสถานะสิ่งของแบบอัตโนมัติ`,
      allowOutsideClick: false,
      confirmButtonText: 'ยืนยัน',
      confirmButtonColor: '#ec1b23',
      showCancelButton: true,
      cancelButtonText: 'ยกเลิก',
    }).then((result) => {
      if (result.value) {
        requestAnimationFrame(() => {
          (this.$refs.otpObserver as Vue & { reset: () => any }).reset();
        });
        this.resendOTP();
        this.state = STATE.OTP_VERIFY;
      }
    });
  }

  private async sendOTP() {
    try {
      const params = {
        telephone: this.form.telephone,
      };
      const res = await this.$http.post(`/api/users/tracking-register/otp`, params);
      this.otpRefCode = res.data.otpRefCode;
    } catch (err) {
      this.showError(err);
    }
  }

  private resendOTP() {
    if (this.resendCounter === 0) {
      this.resendCounter = 11;
      this.sendOTP();
    }

    if (this.resendCounter >= 11) {
      this.resendCounter--;
      this.ivalId = setInterval(() => {
        this.resendCounter--;
        if (this.resendCounter <= 0) {
          clearInterval(this.ivalId);
        }
      }, 1000);
    }
  }

  private submitRegister() {
    Swal.fire({
      title: 'กำลังส่งข้อมูล',
      allowOutsideClick: false,
      onBeforeOpen: async () => {
        Swal.showLoading();
        try {
          this.form.firstName = this.form.firstName.trim();
          this.form.lastName = this.form.lastName.trim();
          this.form.nickname = this.form.nickname ? this.form.nickname.trim() : null;
          this.form.email = this.form.email ? this.form.email.trim() : null;
          this.otpCode = this.otpCode ? this.otpCode.trim() : null;
          const params = {
            ...this.form,
            otpRefCode: this.otpRefCode,
            otpCode: this.otpCode,
            isConsent: this.isConsent,
          };
          const res = await this.$http.post(`/api/users/tracking-register`, params);
          Swal.close();
          Swal.fire({
            title: 'ติดตามสถานะ',
            html: `<p class="text-center"><img src="/images/submit-check.png" style="width: 25%;" /></p>
              <div>ติดตามสถานะสิ่งของเรียบร้อยแล้ว</div>`,
            showConfirmButton: true,
          }).then((result) => {
            this.resetData();
            this.state = STATE.REGISTER_FORM;
            this.$router.push({ name: 'receiver' });
          });
        } catch (err) {
          this.showError(err);
        }
      },
    });
  }

  private cancelRegister() {
    Swal.fire({
      title: 'ยืนยัน',
      text: `ยกเลิกติดตามสถานะสิ่งของแบบอัตโนมัติ`,
      allowOutsideClick: false,
      confirmButtonText: 'ยืนยัน',
      confirmButtonColor: '#ec1b23',
      showCancelButton: true,
      cancelButtonText: 'ยกเลิก',
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'กำลังส่งข้อมูล',
          allowOutsideClick: false,
          onBeforeOpen: async () => {
            Swal.showLoading();
            try {
              const res = await this.$http.delete('/api/users/tracking-register');
              Swal.close();
              Swal.fire({
                title: 'ติดตามสถานะ',
                html: `<p class="text-center"><img src="/images/submit-check.png" style="width: 25%;" /></p>
                  <div>ยกเลิกติดตามสถานะสิ่งของเรียบร้อยแล้ว</div>`,
                showConfirmButton: true,
              }).then((result) => {
                this.resetData();
                this.state = STATE.REGISTER_FORM;
                this.$router.push({ name: 'receiver' });
              });
            } catch (err) {
              this.showError(err);
            }
          },
        });
      }
    });

  }

  private resetData() {
    this.userTrackingRegister = null;
    this.form = {
      firstName: null,
      lastName: null,
      telephone: null,
      nickname: null,
      email: null,
    };
    this.otpRefCode = null;
    requestAnimationFrame(() => {
      (this.$refs.observer as Vue & { reset: () => any }).reset();
    });
    requestAnimationFrame(() => {
      (this.$refs.otpObserver as Vue & { reset: () => any }).reset();
    });
  }

  private maskTelephone(telephone: string) {
    if (!telephone) {
      return;
    }
    const masks = telephone.match(/(\d{3})(\d{4})(\d{3})/);
    return `${masks[1]}xxxx${masks[3]}`;
  }

  private backRegisterForm() {
    this.state = STATE.REGISTER_FORM;
  }

  private confirmOTP() {
    this.submitRegister();
  }

  private showError(err) {
    console.error(err);
    let text = 'กรุณาลองใหม่อีกครั้ง';
    if (err.body) {
      const { code, message } = err.body;
      if (code === 'invalid_data') {
        text = `ข้อมูลไม่ถูกต้อง`;
      }

      if (code === 'user_not_found' || code === 'not_found') {
        text = `ไม่พบข้อมูล`;
      }

      if (code === 'user_already_register') {
        text = `ไม่สามารถลงทะเบียนได้เนื่องจากคุณเคยลงทะเบียนไปแล้ว`;
      }

      // OTP error code
      if (code === 'E001') {
         text = 'ไม่พบข้อมูล Configuration ที่เชื่อมโยงกับชื่อผู้ใช้งาน';
      }

      if (code === 'E002') {
         text = 'ทำการขอรับรหัส OTP เกินกว่าจำนวนครั้งที่กำหนด';
      }
    }
    Swal.close();
    Swal.fire({
      title: 'เกิดข้อผิดพลาด',
      text,
      focusConfirm: false,
      focusCancel: false,
      confirmButtonText: 'ตกลง',
      confirmButtonColor: '#ec1b23',
    }).then((result) => {
      this.state = STATE.REGISTER_FORM;
    });
  }
}
